import React from 'react'
import { useQuery } from '@apollo/client'
import { map } from 'lodash-es'
import { Select, Form } from 'antd'
import PropTypes from 'prop-types'

import { SCRAPING_LOGS_MENUS_FOR_SESSION } from '../../../graphql/queries'

const ScrapingSessionMenuFilter = ({ sessionId, menuId, onChange, label }) => {
  const { data: { scrapingLogsMenusForSessionId } = {}, loading } = useQuery(
    SCRAPING_LOGS_MENUS_FOR_SESSION,
    {
      variables: { sessionId },
      fetchPolicy: 'no-cache',
    },
  )

  return (
    <Form.Item label={label}>
      <Select
        showSearch
        allowClear
        defaultValue={menuId}
        style={{ width: '100%' }}
        loading={loading}
        onChange={onChange}
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {map(scrapingLogsMenusForSessionId, ({ menuId, menuUrl }) => (
          <Select.Option
            key={menuId}
            value={menuId}
          >{`${menuId} - ${menuUrl}`}</Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

ScrapingSessionMenuFilter.propTypes = {
  sessionId: PropTypes.string.isRequired,
  menuId: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
}

ScrapingSessionMenuFilter.defaultProps = {
  menuId: undefined,
  label: 'Menu',
}

export default ScrapingSessionMenuFilter
